<template>
    <div>
        兑换地址：<el-link :href="redeemUrl" target="_blank">{{redeemUrl}}</el-link>
        <div class="page-filter-box MT10">
            <el-row :gutter="20">
                <!-- <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.code" placeholder="请输入兑换码" size="small"></el-input>
                </el-col> -->
				
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-input v-model="params.searchValue" class="input-with-select" size="small">
				        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
							<el-option label="兑换码" :value="4"></el-option>
				            <el-option label="兑换手机" :value="1"></el-option>
							<el-option label="赠票ID" :value="3"></el-option>
				            <el-option label="赠票名称" :value="2"></el-option>							
							<el-option label="观演人证件姓名" :value="5"></el-option>
							<el-option label="观演人证件号码" :value="6"></el-option>
				        </el-select>
				    </el-input>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.redeemStatus" placeholder="请选择" size="small">
                        <el-option label="不限制兑换状态" value=""></el-option>
                        <el-option label="仅看未兑换的" :value="0"></el-option>
                        <el-option label="仅看已兑换的" :value="1"></el-option>
                        <!-- <el-option label="仅看已作废的" :value="2"></el-option> -->
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.ticketStatus" placeholder="请选择" size="small">
						<el-option label="不限制有效状态" value=""></el-option>
						<el-option label="仅看正常的" :value="1"></el-option>						
						<el-option label="仅看已作废的" :value="0"></el-option>
						<el-option label="仅看已过期的" :value="2"></el-option>
					</el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/activity/redeemCodeCancel')" type="primary" icon="el-icon-delete" @click="cancelCode()" size="small" :disabled="haveEditAudit" plain>批量作废</el-button>
            <el-button v-if="$utils.have('/activity/redeemCodeCancel')" type="primary" icon="el-icon-download" @click="download" size="small" plain :loading="downLoading">导出兑换码</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe @selection-change="handleSelectionChange">
                <el-table-column type="selection"></el-table-column>
               <!-- <el-table-column prop="id" label="ID">
                </el-table-column> -->
                <el-table-column prop="redeemStatus" label="状态" min-width="140">                    
					<template slot-scope="scope">
						<p>兑换状态：<span v-if="scope.row.redeemStatus == 0">未兑换</span>
                        <span v-else-if="scope.row.redeemStatus == 1" class="color-success">已兑换</span></p>
						<p>有效状态： <span v-if="scope.row.status == 0" class="color-info">已作废</span>
                        <span v-if="scope.row.status == 1">正常</span>
						<span v-if="scope.row.status == 2" class="color-info">已过期</span></p>						
					</template>
                </el-table-column>
				<el-table-column prop="ticketId" label="票品id" min-width="120"></el-table-column>
				<el-table-column prop="ticketName" label="赠票名称" min-width="120" show-overflow-tooltip></el-table-column>	
				<el-table-column label="是否实名" min-width="80">					
					<template slot-scope="scope">
						<span v-if="scope.row.realName == 0">否</span>
						<span v-else-if="scope.row.realName == 1">是</span>
					</template>
				</el-table-column>					
				<el-table-column prop="code" label="兑换码" min-width="140"> </el-table-column>
                <el-table-column prop="telephone" label="兑换手机号" min-width="120"></el-table-column>
                <el-table-column  label="观演人信息"  min-width="150">
                	<template slot-scope="scope">
                		<p v-if="scope.row.documentName">{{scope.row.documentName}}</p>
                		<p v-if="scope.row.documentNumber">{{scope.row.documentNumber}}</p>	
                		<p v-if="!scope.row.documentNumber && !scope.row.documentNumber" class="color-danger">暂无</p>	
                	</template>
                </el-table-column>
				<el-table-column  label="座位号信息" min-width="220">
					<template slot-scope="scope">
						<template v-if="scope.row.seat ">
							{{scope.row.seat}}
						</template>
						<template v-else>
							<p class="color-danger">暂无</p>
						</template>
					</template>
				</el-table-column>
				<el-table-column prop="createUser" label="生成人"></el-table-column>
                <el-table-column label="时间" min-width="220">
					<template slot-scope="scope">
						<p>生成时间：{{scope.row.createTime}}</p>
						<p v-if="scope.row.endTime">兑换截止：{{scope.row.endTime}}</p>
						<p>兑换时间：<template v-if="scope.row.time">{{scope.row.time}}</template><template v-else>暂未兑换</template></p>	
						<p>作废时间：<template v-if="scope.row.invalidTime">{{scope.row.invalidTime}}</template><template v-else>暂未作废</template></p>	
					</template>
                </el-table-column>                
                
                <el-table-column v-if="!haveEditAudit" fixed="right" label="操作" width="160">
                    <template slot-scope="{row} = scope">
                        <el-button v-if="$utils.have('/activity/redeemCodeCancel') && row.status == 1" type="text" size="small" icon="el-icon-document-delete"
                            @click="cancelCode(row.id)">作废删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {downloadFileTmp} from '@/assets/js/commonApi.js';
const defaultParams = {
    pageNo: 1,
    searchValues: "",
    redeemStatus: "", //兑换状态 0:未兑换 1：已兑换
	searchType:4,
	ticketStatus:''//有效状态 1：正常 0：作废（兑换码才用）
}
export default {
    props: {
        activityId: {
            type: [Number, String],
            default: () => null
        },
        haveEditAudit: {
            type: Boolean,
            default: false
        },
        isSeat: {
            type:[Number,String],
            default: 0
        }
    },
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageSize: this.$pageSizes[0],
            },
            listLoading: true,
            recordIds: [],
            downLoading:false,
            redeemUrl: `${process.env.VUE_APP_SSWAP_URL}/pages/special/redeem`
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/activity/redeemCodeRecords",
                method: "POST",
                data: {
                    ...this.params,
                    activityId: this.activityId
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.data = null;
                        this.dataList = [];
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //全选、反选
        handleSelectionChange(val) {
            this.recordIds = val.map( v => v.id );
        },
        //作废
        cancelCode(id){
            let  _recordIds = [], _msg = "";
            if( id ){
                _recordIds = [id];
                _msg = "确定要作废删除当前兑换码?"
            }else{
                _recordIds = [...this.recordIds]
                if( _recordIds.length < 1 ){
                    return this.$message.error("请选择需要作废删除的兑换码");
                }
                _msg = "仅未兑换状态兑换码支持批量作废，时效原因，批量作废时部分兑换码若已兑换，系统会自动跳过";
            }
            this.$confirm(_msg, '作废删除', {
                // type: 'warning',
                center: true,
                closeOnClickModal: false,
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/activity/redeemCodeCancel',
                    method: 'POST',
                    params: {recordIds: _recordIds.toString()}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        let timer = setTimeout(() => {
                            this.getDataList();
                            clearTimeout(timer);
                        },500)
                        
                    }else{
                        this.$message.error(msg || '请求失败');
                        this.listLoading = false;
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                    this.listLoading = false;
                }).finally(() => {
                    // this.listLoading = false;
                });
            })
        },
        async download(){
            let filePath, fileName;
            this.downLoading = true;
            const res = await this.$request({
                url:'/activity/downloadRedeemCodeRecords',
                method: 'post',
                data: {
                    ...this.params,
                    activityId: this.activityId
                },
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result} = res.data;
            if(state == 1 && result){
                filePath = result.url;
                fileName = result.fileName;
            }else{
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath, fileName+'.'+this.$utils.getFileType(filePath));

            this.downLoading = false;
        },
    }
}
</script>
<style lang="scss" scoped>

</style>